import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import { GetServerSideProps } from 'next'
import { RegionalPagesPath, regionalPagesProps } from 'regions/runtime-components/pages-props'
import { InvestGift, InvestorsFondPageProps } from 'screens/invest-gift'
import { getSavingsParams } from 'ssr-resolvers/savings-params'

const InvestGiftPage: NextPageFC<InvestorsFondPageProps> = (props) => InvestGift(props)

InvestGiftPage.layout = regionalPagesProps[RegionalPagesPath.invest].layout

InvestGiftPage.headProps = {
	title: pagesTitles[PagesPath.investGift].title,
	description:
		'Cертификат на Сбережение от 10 тысяч рублей для ценителей необычных и полезных поздравлений.',
	ogImageName: 'new-invest-og-img.jpg',
}

export const getServerSideProps: GetServerSideProps<InvestorsFondPageProps> = async () => {
	try {
		const [pledgeSummary, savingsParams] = await Promise.all([
			httpService.get<PledgeSummaryResponse>(apiUrls.getSummaries()),
			getSavingsParams(),
		])

		const result = {
			props: {
				pageSettings: {
					savings: { params: savingsParams },
					pledgeSummary,
				},
			},
		}
		return result
	} catch (e) {
		return {
			props: {
				pageSettings: {},
			},
		}
	}
}

export default InvestGiftPage
